import { Expose } from "class-transformer";

export default class ModelWarningBlockNotification {
	@Expose({name: 'isActive'})
	private _isActive: boolean | undefined = false;
	@Expose({name: 'ru'})
	private _ru: string | null | undefined = null;
	@Expose({name: 'en'})
	private _en: string | null | undefined = null;
	@Expose({name: 'kz'})
	private _kz: string | null | undefined = null;
	@Expose({name: 'uz'})
	private _uz: string | null | undefined = null;
	@Expose({name: 'tag'})
	private _tag: string | null | undefined = null;
	@Expose({name: 'order'})
	private _order: number | null | undefined = null;

	get isActive(): boolean | undefined {
		return this._isActive;
	}

	get ru(): string | null | undefined {
		return this._ru
	}

	get en(): string | null | undefined {
		return this._en;
	}

	get kz(): string | null | undefined {
		return this._kz;
	}

	get uz(): string | null | undefined {
		return this._uz;
	}

	get tag(): string | null | undefined {
		return this._tag;
	}

	get order(): number | null | undefined {
		return this._order;
	}
}
